import { CommonModule } from '@angular/common';
import {
    CUSTOM_ELEMENTS_SCHEMA,
    ModuleWithProviders,
    NgModule,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbDatepickerModule } from '@cmps/ng-bootstrap';
import { NgChartModule } from '@cmps/ng-chart';
import { SelectModule } from '@cmps/ng-select';
import {
    CmpsButtonGroupModule,
    CmpsButtonModule,
    CmpsIconModule,
    CmpsPortalModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../common/common.module';
import { CmpsLazyI18nModule } from '../i18n/i18n.module';
import { PerformanceDataService } from '../performance-data/performance-data.service';

import { CustomizeColumnsInsightComponent } from './customize-columns.insight.component';
import { CustomizeMetricsInsightComponent } from './customize-metrics.insight.component';
import { CustomizePillarsInsightComponent } from './customize-pillars.insight.component';
import { CustomizeInsightComponent } from './customize.insight.component';
import {
    ColumnElementComponent,
    DefaultCellComponent,
    DefaultGridComponent,
    DefaultRowComponent,
    ExpandMetricComponent,
    ExpandPillarComponent,
    MetricElementComponent,
    NodeElementComponent,
} from './grid.insight.render';
import { InsightEpicBridge } from './insight.epic.bridge';
import { TranslationIdMap } from './insight.i18n';
import { InsightService } from './insight.service';
import { LegendInsightComponent } from './legend.insight.component';
import { NestedNodeSelectInsightComponent } from './nested-node-select.insight.component';
import { PathInsightComponent } from './path.insight.component';
import { PeriodInsightComponent } from './period.insight.component';
import { PersistInsightComponent } from './persist.insight.component';
import { PopUpComponent, PopUpService } from './pop-up.service';
import { PresentationInsightComponent } from './presentation.insight.component';
import { RolloverInsightComponent } from './rollover.insight.component';
import { SelectedVisualItemInsightComponent } from './selected-visual-item.insight.component';
import { SelectionCollapseInsightDirective } from './selection-collapse.insight.directive';
import { SelectionSummaryInsightComponent } from './selection-summary.insight.component';
import { VisualItemInsightComponent } from './visual-item.insight.component';

@NgModule({
    imports: [
        CmpsButtonGroupModule,
        CmpsButtonModule,
        CmpsCommonModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsPortalModule,
        CmpsTooltipModule,
        CommonModule,
        NgChartModule,
        NgbDatepickerModule,
        ReactiveFormsModule,
        SelectModule,
    ],
    declarations: [
        ColumnElementComponent,
        CustomizeColumnsInsightComponent,
        CustomizeInsightComponent,
        CustomizeMetricsInsightComponent,
        CustomizePillarsInsightComponent,
        DefaultCellComponent,
        DefaultGridComponent,
        DefaultRowComponent,
        ExpandMetricComponent,
        ExpandPillarComponent,
        LegendInsightComponent,
        MetricElementComponent,
        NestedNodeSelectInsightComponent,
        NodeElementComponent,
        PathInsightComponent,
        PeriodInsightComponent,
        PersistInsightComponent,
        PopUpComponent,
        PresentationInsightComponent,
        RolloverInsightComponent,
        SelectedVisualItemInsightComponent,
        SelectionCollapseInsightDirective,
        SelectionSummaryInsightComponent,
        VisualItemInsightComponent,
    ],
    exports: [
        CmpsCommonModule,
        ColumnElementComponent,
        CustomizeColumnsInsightComponent,
        CustomizeInsightComponent,
        CustomizeMetricsInsightComponent,
        CustomizePillarsInsightComponent,
        DefaultCellComponent,
        DefaultGridComponent,
        DefaultRowComponent,
        ExpandMetricComponent,
        ExpandPillarComponent,
        LegendInsightComponent,
        MetricElementComponent,
        NestedNodeSelectInsightComponent,
        NodeElementComponent,
        PathInsightComponent,
        PeriodInsightComponent,
        PersistInsightComponent,
        PresentationInsightComponent,
        SelectedVisualItemInsightComponent,
        SelectionCollapseInsightDirective,
        SelectionSummaryInsightComponent,
        VisualItemInsightComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CmpsInsightModule {
    static forRoot(): ModuleWithProviders<CmpsInsightModule> {
        return {
            ngModule: CmpsInsightModule,
            providers: [
                InsightEpicBridge,
                InsightService,
                PerformanceDataService,
                PopUpService,
            ],
        };
    }
}
